import { CheckCircle2, LoaderCircle } from "lucide-react";
import { getLeadName, pipelineStages } from "../../data/leadPipeline";

export default function LeadPipelineEntry({ lead, onStatusChange, savingLeadId, savedLeadId }) {
  const currentStatus = pipelineStages.some((stage) => stage.value === lead.status)
    ? lead.status
    : "new";
  const isSaving = savingLeadId === lead.lead_id;
  const isSaved = savedLeadId === lead.lead_id;

  return (
    <article className="lead-pipeline-entry" data-testid={`lead-pipeline-card-${lead.lead_id}`}>
      <span data-testid={`lead-pipeline-kind-${lead.lead_id}`}>{lead.kind}</span>
      <h3 data-testid={`lead-pipeline-name-${lead.lead_id}`}>{getLeadName(lead)}</h3>
      <p data-testid={`lead-pipeline-company-${lead.lead_id}`}>
        {lead.company || lead.email}
      </p>
      <label>
        <span className="lead-pipeline-label">Pipeline stage</span>
        <select
          aria-label={`Pipeline stage for ${getLeadName(lead)}`}
          data-testid={`lead-pipeline-status-${lead.lead_id}`}
          disabled={isSaving}
          onChange={(event) => onStatusChange(lead, event.target.value)}
          value={currentStatus}
        >
          {pipelineStages.map((stage) => (
            <option key={stage.value} value={stage.value}>
              {stage.label}
            </option>
          ))}
        </select>
      </label>
      {isSaving && (
        <p className="lead-pipeline-saving" data-testid={`lead-pipeline-saving-${lead.lead_id}`}>
          <LoaderCircle aria-hidden="true" className="spin" size={13} /> Saving
        </p>
      )}
      {isSaved && (
        <p className="lead-pipeline-saved" data-testid={`lead-pipeline-saved-${lead.lead_id}`}>
          <CheckCircle2 aria-hidden="true" size={13} /> Updated
        </p>
      )}
    </article>
  );
}